import type { FC } from 'react';
import AntRadio from 'antd/es/radio';
import type {
  RadioProps as AntRadioProps,
  RadioChangeEvent,
  RadioGroupProps as AntRadioGroupProps,
} from 'antd/es/radio';
import { cn } from 'app/lib/utils';

export interface RadioProps extends AntRadioProps {}

export interface RadioGroupProps extends AntRadioGroupProps {
  /** Highlights the group with an error border */
  error?: boolean;
}

const RadioBase: FC<RadioProps> = (props) => <AntRadio {...props} />;

const Group: FC<RadioGroupProps> = ({ error, className, ...rest }) => (
  <AntRadio.Group
    className={cn(
      error && 'border border-red-500 rounded p-2 bg-red-50',
      className
    )}
    {...rest}
  />
);

/**
 * Radio façade over antd `Radio`; `Group` accepts a semantic `error` prop.
 */
export const Radio = RadioBase as typeof RadioBase & { Group: typeof Group };
Radio.Group = Group;

export type { RadioChangeEvent };
export default Radio;
